import { Component, Input, OnInit } from '@angular/core';
import { NavParams, Platform, ModalController } from '@ionic/angular';
import { Moment } from 'moment';
import { Utilities, DateRange } from '../../../utilities/utilities';

@Component({
  selector: 'smr-date-range-selector',
  templateUrl: './date-range-selector.component.html',
  styleUrls: ['./date-range-selector.component.scss'],
})
export class DateRangeSelectorComponent{

  public currentDate: Date;

  @Input() pickMode: string = 'range';
  @Input() showJumpCalendar: boolean = true;

  public defaultSelection: any;

  public touchUI: boolean = false;

  // public alwaysShowCalendars: boolean = true;

  // public ranges: any = {
  //   'Today': [moment(), moment()],
  //   'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
  //   'Last 7 Days': [moment().subtract(6, 'days'), moment()],
  //   'Last 30 Days': [moment().subtract(29, 'days'), moment()],
  //   'This Month': [moment().startOf('month'), moment().endOf('month')],
  //   'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
  // }

  public selectedDates: { startDate: Date, endDate: Date} = { startDate: null, endDate: null };

  constructor (private modalCtrl: ModalController,
    private navParams: NavParams,
    private platform: Platform) {

    if (this.platform.is('capacitor')) {
      this.touchUI = true;
    }

    this.currentDate = this.navParams.get('date');

    if (!this.currentDate) {
      this.currentDate = new Date();
    }

    this.defaultSelection = Utilities.cloneDate(this.currentDate);

    // this.selectedDates = { startDate: moment(this.currentDate), endDate: moment(this.currentDate)};

    if (this.pickMode === 'single') {
      // this.defaultSelection = this.currentDate;
      this.selectedDates.startDate = this.defaultSelection;
    }

    const start: Date = this.navParams.get('start');
    const end: Date = this.navParams.get('end');
    if (this.pickMode === 'range' && start && end) {
      this.defaultSelection = [start, end];
      this.selectedDates = { startDate: start, endDate: end}
    }
  }

  public onDismiss () {
    this.modalCtrl.dismiss();
  }

  // public dateRangeSelected (range: IDateRange) {
  //   this.viewCtrl.dismiss(range);
  // }

  // public choosedDate ($event: { chosenLabel: string, startDate: Moment, endDate: Moment}) {
  //   this.selectedDates = $event;
  // }

  // public datesUpdated ($event) {
  // }

  public selectDate () {
    if (this.pickMode === 'single') {
      this.modalCtrl.dismiss({
        date: this.selectedDates.startDate
      });
    } else {
      this.modalCtrl.dismiss({
        start: this.selectedDates.startDate,
        end: this.selectedDates.endDate
      });
    }
  }

  public onSelect ($event: Date) {

    if (this.pickMode === 'single') {
      this.selectedDates.startDate = $event;
      this.selectDate()
    } else {
      if (!this.selectedDates.startDate) {
        this.selectedDates.startDate = $event;
      } else if (!this.selectedDates.endDate) {
        this.selectedDates.endDate = $event;
      } else {
        this.selectedDates.startDate = $event;
        this.selectedDates.endDate = null;
      }
    }
  }

  public isEnabled () : boolean {
    if (this.pickMode === 'single') {
      return this.selectedDates.startDate !== null;
    } else {
      return this.selectedDates.startDate !== null && this.selectedDates.endDate !== null;
    }
  }

  public pickRange (label: string) {
    let range: DateRange;

    switch (label) {
      case "today":
        range = { start: new Date(), end: new Date()};
        break;
      case "yesterday":
        range = { start: Utilities.subtractDays(new Date(), 1), end: Utilities.subtractDays(new Date(), 1)};
        break;
      case "this-week":
        range = Utilities.getThisWeekRange();
        break;
      case "last-week":
        range = Utilities.getLastWeekRange();
        break;
      case "this-month":
        range = Utilities.getThisMonthRange();
        break;
      case "last-month":
        range = Utilities.getLastMonthRange();
        break;
      case "this-year":
        range = Utilities.getThisYearRange();
        break;
      case "last-year":
        range = Utilities.getLastYearRange();
        break;
      default:
        break;
    }
     
    if (range) {
      this.modalCtrl.dismiss(range);
    }
  }

  public jumpDate (jumpCount: number) {
    // check if the option is 'today'
    if (jumpCount === 0) {
      this.modalCtrl.dismiss({date: new Date()});
      return;
    }

    this.modalCtrl.dismiss({
      date: Utilities.addDays(this.currentDate, jumpCount)
    });
  }

}
